import { getApiCall } from '../utils/Api';

// eslint-disable-next-line import/prefer-default-export
export const getOverAllReports = async (queryParams) => {
  const result = await getApiCall(`/reports/overall${queryParams || ''}`);
  return result.data;
};
